import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {Pagination, Student} from "../../../types/studentsSchema";
import {StudentTest} from "features/model/types/test/studentTestById";


const initialState = {
    tests: [] as StudentTest[],
    pagination: {} as Pagination,
    isLoading: true,
    error: null,
}


const testsStudentsByIdSlice = createSlice({
    name: "testsStudents",
    initialState,
    reducers: {
        setTestsStudentsById: (state, action) => {
            const { items, pagination } = action.payload;
            state.tests = items;
            state.pagination = pagination;
            state.isLoading = false;
            state.error = null;
        },
        setLoading: (state, action:PayloadAction<{isLoading:boolean}>) => {
            state.isLoading = action.payload.isLoading;
        },
        setError: (state, action) => {
            state.error = action.payload;
        },
    },
});

export const { setTestsStudentsById, setLoading, setError } = testsStudentsByIdSlice.actions;

export const testsStudentsByIdReducer = testsStudentsByIdSlice.reducer;
